<script lang="ts" setup>
const { appURL } = useRuntimeConfig().public
const { locale } = useI18n()

definePageMeta({
  layout: false,
})
</script>

<template>
  <section class="international-visits">
    <nav class="navigation">
      <div class="navigation__content">
        <NuxtLink
          :to="`${appURL}${locale === 'en' ? '/en' : ''}`"
          title="Benefit Logo"
          aria-label="Benefit Logo"
        >
          <img
            src="/logo.svg"
            class="navigation__logo"
          >
        </NuxtLink>
      </div>
    </nav>

    <div class="international-visits__content">
      <p class="international-visits__pdf">
        <strong>
          <a
            href="/docs/International_Visits_Information_clause_BS_Croatia_v1.pdf"
            target="_blank"
          >
            International Visits Information clause BS Croatia
          </a>
        </strong>
      </p>

      <p class="international-visits__pdf">
        <strong>
          <a
            href="/docs/International_Visits_information_clause_BS_Bulgaria_v1.pdf"
            target="_blank"
          >
            International Visits Information clause BS Bulgaria
          </a>
        </strong>
      </p>

      <p class="international-visits__pdf">
        <strong>
          <a
            href="/docs/International_Visits_information_clause_BS_Poland_v1.pdf"
            target="_blank"
          >
            International Visits Information clause BS Poland
          </a>
        </strong>
      </p>

      <p class="international-visits__pdf">
        <strong>
          <a
            href="/docs/International_Visits_Information_clause_BS_Slovakia_v1.pdf"
            target="_blank"
          >
            International Visits Information clause BS Slovakia
          </a>
        </strong>
      </p>

      <p class="international-visits__pdf">
        <strong>
          <a
            href="/docs/International_Visits_Information_clause_BS_Turkiye_v1.pdf"
            target="_blank"
          >
            International Visits Information clause BS Türkiye
          </a>
        </strong>
      </p>

      <p class="international-visits__pdf">
        <strong>
          <a
            href="/docs/International_Visits_Information_clause_English_v1.pdf"
            target="_blank"
          >
            International Visits Information clause BS English
          </a>
        </strong>
      </p>

      <p class="international-visits__pdf">
        <strong>
          <a
            href="/docs/International_Visits_Information_clause_BS_Czech_Republic_v1.pdf"
            target="_blank"
          >
            International Visits Information clause BS Czech Republic
          </a>
        </strong>
      </p>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.international-visits {
  &__content {
    padding: 10rem 3.2rem;
  }

  &__pdf {
    margin: 0 0 2rem;
    font-weight: 700;
    font-size: 1.6rem;
    line-height: 1.8rem;

    a {
      color: #3944a8;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.navigation {
  position: fixed;
  z-index: 99;
  width: 100%;
  padding-top: 2rem;
  padding-bottom: 2rem;
  background-color: transparent;

  &__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 156rem;
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding-right: 2.4rem;
    padding-left: 2.4rem;
  }

  &__logo {
    width: 9.6rem;
    height: auto;

    @include atM {
      width: 13.2rem;
    }
  }
}
</style>
